export default function Scrollable(obj, { props } = {} /* for func components */) {
  this.componentDidMount = () => {
    const scroll_ref = (obj?.props || props).containerRef.current;
    scroll_ref.scrollTo(0,0);
  };
}
